import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import "./DashboardImpersonationResult.scss";

const DashboardImpersonationResult = ({
  composedName = "",
  dataTable,
  ...props
}) => {
  const { t } = useTranslation();

  const safeDataTable = dataTable || [];

  return (
    <div
      className="DashboardImpersonationResult"
      data-testid="DashboardImpersonationResult"
      {...props}
    >
      <h3 className="headline-bold-fs4">
        {t("dashboard.impersonation.title")}:
      </h3>

      <div className="result-container">
        <div className="consumer-name">
          <h2 className="headline-bold-fs4">{composedName}</h2>
        </div>
        <div className="table-data-result-container">
          {safeDataTable.map((item, i) => (
            <div className="table-data-result-item" key={i}>
              <div className="head-item paragraph-small-fs9">{item.head}</div>
              <div className="text-item paragraph-large-fs7">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

DashboardImpersonationResult.propTypes = {
  composedName: PropTypes.string,
  dataTable: PropTypes.arrayOf(
    PropTypes.shape({
      head: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

export default DashboardImpersonationResult;
